import { Component, inject, Input } from '@angular/core';
import { AppStateService } from '../../../../core/services/app-state.service';

@Component({
    selector: 'app-goal-bar-chart',
    templateUrl: './goal-bar-chart.component.html',
    styleUrls: ['./goal-bar-chart.component.scss'],
    standalone: false
})
export class GoalBarChartComponent {
    private appStateService: AppStateService = inject(AppStateService);

    public get isSidebarExpanded(): boolean {
        return this.appStateService.isSidebarExpanded;
    }

    @Input()
    public goal: any;

    @Input()
    public subTheme: any;

    public getTncContributionHeight(percent: number) {
        if (percent < 2) {
            return 2;
        }
        return percent;
    }

    public getTncContributionText(contribution: number): string {
        if (contribution < 1) {
            return '<1%';
        }
        return contribution.toFixed(0) + '%';
    }

}
